<template>
  <div class="signature-page" :class="{ 'no-head': !showHead }">
    <div class="header" :class="{ ios: isIos }" v-if="showHead">
      <i class="iconfont icon-zuoye" @click="exit"></i>
      <span>签名</span>
    </div>
    <div class="body" v-if="!loading">
      <div class="container" v-if="isMobile && isValidUrl">
        <template v-if="showWrite">
          <div class="canvas-wrapper">
            <div class="tip">签字区</div>
            <canvas id="canvas"></canvas>
          </div>
          <div class="btn-wrap">
            <button class="button button-primary" @click="clear" @touchend="clear">重签</button>
            <button class="button button-primary" @click="submit" @touchend="submit">确认</button>
          </div>
        </template>
        <template v-else>
          <div class="submit-result">
            <i class="iconfont icon-chenggong"></i>
            <span>保存成功</span>
          </div>
          <div class="result-btn-wrap">
            <button class="button button-primary" @click="checkCode">
              重签
            </button>
            <button class="button button-hollow" @click="exit" v-if="showExit">
              退出
            </button>
          </div>
        </template>
      </div>
      <div class="page-tip" v-else>
        {{
          isMobile
            ? '链接已过期'
            : '请使用移动设备扫码，或修改浏览器设备类型标识'
        }}
      </div>
    </div>
  </div>
</template>
<script>
import SignaturePad from 'signature_pad'
import Obs from 'ulearning-obs/dist/obs-huawei.js'
import cookies from '@/utils/cookie'
import { API_HOST, RESOURCE_SERVER_HOST } from '@/config'
import { device } from '@/utils/device'
import { disableZoom, setWxConfig } from '@/utils/index.js'
import { exitApp } from '@/plugins/cordova/index.js'
import websocket from '@/utils/websocket.js'
import { saveEleSignUrl, checkCode } from '@/api/courseApi/index.js'
export default {
  name: 'SignaturePage',
  data() {
    return {
      isMobile: device.isMobile,
      isIos: device.isRunningStandalone && device.platform.ios,
      showHead: !device.platform.inApp,
      showExit: !device.platform.inApp || device.platform.weixin,
      loading: true,
      isValidUrl: false,
      showWrite: true,
      signaturePad: null
    }
  },
  computed: {
    code() {
      return this.$route.query.code
    },
  },
  watch: {
    $route() {
      this.init()
    },
    code() {
      this.init()
    },
  },
  created() {
    setWxConfig()
    this.init()
  },
  mounted() {
    disableZoom()
    websocket.registMessageListener(2, (data) => {
      console.log('接收消息')
      if (data.result === 1) {
        this.showWrite = false
      } else {
        this.$toast('保存失败')
      }
    })
    window.addEventListener('popstate', this.exit, false)
    window.addEventListener('resize', this.resizeCanvas, false)
    document.body.classList.add('page-hidden')
  },
  methods: {
    init() {
      cookies.set('token', this.$route.query.token)
      window.MYAUTHORIZATION = this.$route.query.token
      this.checkCode().then(() => {
        if (this.isMobile && this.isValidUrl) {
          // websocket没有接口，暂时不用
          // this.$nextTick(() => {
          //   websocket.connect(this.code)
          // })
          this.pushState()
        }
      })
    },
    pushState() {
      device.isRunningStandalone &&
        window.history.pushState(null, null, location.href)
    },
    checkCode(isInit = true) {
      return checkCode(this.code)
        .then(( { result }) => {
          this.isValidUrl = result
          this.loading = false
          this.showWrite = true
          if (isInit && this.isMobile && this.isValidUrl) {
            this.$nextTick(() => {
              this.initCanvas()
            })
          }
          !this.isValidUrl && this.saveToast && this.$toast.clear()
        })
        .catch(() => {
          this.loading = false
          this.$toast('请求失败')
        })
    },
    setCanvasSize(canvas) {
      const height =
        document.documentElement.clientHeight || document.body.clientHeight
      canvas.width =
        document.documentElement.clientWidth || document.body.clientWidth
      canvas.height = Math.min(height, canvas.width) - 100
      document.querySelector(
        '.canvas-wrapper'
      ).style.height = `${canvas.height}px`
      // 抗锯齿
      let devicePixelRatio = 1
      if (window.devicePixelRatio) {
          devicePixelRatio = window.devicePixelRatio
          canvas.height = canvas.height * devicePixelRatio;
          canvas.width = canvas.width * devicePixelRatio;      
      }
      let ctx = canvas.getContext('2d')
      ctx.scale(devicePixelRatio, devicePixelRatio);
    },
    resizeCanvas() {
      const canvas = document.getElementById('canvas')
      this.setCanvasSize(canvas)
      this.clear()
    },
    initCanvas() {
      const canvas = document.getElementById('canvas')
      this.setCanvasSize(canvas)
      this.signaturePad = new SignaturePad(canvas, {
        minWidth: 2,
        maxWidth: 4,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        penColor: 'rgb(0, 0, 0)',
      })
    },
    clear() {
      this.signaturePad && this.signaturePad.clear()
    },
    submit() {
      if (!this.signaturePad.isEmpty()) {
        this.saveToast = this.$toast({
          duration: 0,
          forbidClick: true,
          message: '保存中',
        })
        const data = this.signaturePad.toDataURL('image/png')
        this.checkCode(false).then(() => {
          this.isValidUrl && this.saveImage(data)
        })
      } else {
        this.$toast('签字不能为空')
      }
    },
    saveImage(base64) {
      let obs = new Obs({
        uptokenHost: API_HOST,
        authorization: this.$route.query.token,
        obsHost: RESOURCE_SERVER_HOST,
      })
      let blob = obs.dataURLtoBlob(base64)
      blob.ext = '.png'
      blob.name = new Date().getTime() + blob.ext
      obs.startUpload(blob)
      obs.onSuccess = (file) => {
        const url = file.obsHost + '/' + file.key
        saveEleSignUrl({
          key: 'wenhua',
          signId: this.code,
          signUrl: url,
        })
          .then(() => {
            this.saveToast && this.$toast.clear()
            this.showWrite = false
            // 发送关闭弹窗消息
            this.sendRefreshMessage()
          })
          .catch((error) => {
            this.$toast(error.message || '保存失败')
          })
      }
      obs.onError = (_, err) => {
        if (err.code == 50070 || err.code == 50080) {
          this.saveToast && this.$toast.clear()
          this.$dialog
            .alert({
              title: '提示',
              message: '链接已过期',
            })
            .then(() => {
              this.isValidUrl = false
            })
        } else {
          this.$toast('保存失败')
        }
      }
    },
    sendRefreshMessage() {
      const data = JSON.stringify({
        code: 1,
        id: this.code,
        message: 'refresh',
      })
      websocket.sendMessage(this.code, data, null, (err) => {
        console.log(err)
      })
    },
    exit() {
      if (this.showWrite && !this.signaturePad.isEmpty()) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '签名未保存，确定离开吗？',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          })
          .then(() => {
            this.close()
          })
          .catch(() => {
            this.pushState()
          })
      } else {
        this.close()
      }
    },
    close() {
      try {
        window.close()
        wx.closeWindow()
        exitApp()
      } catch (e) {
        console.log(e)
      }
    },
  },
  destroyed() {
    // websocket && websocket.disconnect()
    window.removeEventListener('popstate', this.close)
    window.removeEventListener('resize', this.resizeCanvas)
    document.body.classList.remove('page-hidden')
  },
}
</script>
<style lang="scss" scoped>
.signature-page {
  position: relative;
  height: 100vh;
  font-size: 14px;
  user-select: none;
  overflow: hidden;
  p {
    margin: 0;
  }
  &.no-head {
    border-top: 1px solid $--border-color-base;
  }
  .header {
    display: flex;
    padding: 12px 16px;
    border-bottom: 1px solid $--border-color-base;
    background-color: #ffffff;
    &.ios {
      padding-top: calc(constant(safe-area-inset-top) + 42px);
      padding-top: calc(env(safe-area-inset-top) + 42px);
    }
    .iconfont {
      line-height: 1.5;
      color: $--color-text-secondary;
    }
    span {
      margin: 0 auto;
      font-size: 18px;
      color: #444444;
    }
  }
  .body {
    .container {
      .canvas-wrapper {
        position: relative;
        height: calc(100vw - 100px);
        background-color: #eee;
        overflow: hidden;
        #canvas,
        .tip {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 100%;
        }
        .tip {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 120px;
        }
      }
      .btn-wrap {
        padding: 20px 16px;
        text-align: right;
        .button {
          display: inline-block;
          width: auto;
          min-width: 80px;
          background: $--color-primary;
          & + .button {
            margin-left: 15px;
          }
        }
      }
      .submit-result {
        margin-top: 15vh;
        text-align: center;
        i {
          display: block;
          margin-bottom: 20px;
          font-size: 50px;
          color: $--color-success;
        }
        span {
          font-size: 16px;
        }
      }
      .result-btn-wrap {
        position: fixed;
        left: 50%;
        bottom: 30px;
        transform: translateX(-50%);
        width: calc(100% - 30px);
        max-width: 360px;
        .button + .button {
          margin: 10px 0 0 0;
        }
      }
    }
    .page-tip {
      padding: 200px 30px 0;
      line-height: 1.2;
      text-align: center;
      color: $--color-text-secondary;
    }
  }
}
</style>
<style lang="scss">
.page-hidden {
  overflow: hidden;
}
</style>
